import dayjs from 'dayjs';
import _ from 'lodash';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import env from '../../env';
import { AppClientId } from '../Shared/constants';

dayjs.extend(customParseFormat);

export const parseTransportOrderModel = function(model) {
  if (!model?.id) return {};
  let m = { ...model };

  Object.entries(model?.properties)?.forEach(prop => {
    return (m[prop[0]] = prop[1]?.value);
  });
  return m;
};

export const parseCompanyPhoneNumber = company => {
  const phoneNumber = company?.country_code ? `+${company?.country_code}${company?.phone_number}` : company?.phone_number;

  return phoneNumber;
};
